import { render, staticRenderFns } from "./Principles.vue?vue&type=template&id=ead4f4e0&"
import script from "./principles.ts?vue&type=script&lang=ts&"
export * from "./principles.ts?vue&type=script&lang=ts&"
import style0 from "./principles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports